exports.IDS = {
  // IMG_URL: "http://127.0.0.1:2002",

  IMG_URL: "https://node.profcymafoundation.com",
  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 1,
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },
  status: {
    Pending: 1,
    Rejected: 2,
    Accepted: 3,
  },
};
